import React from "react";
import { useState } from "react"
import ExclusiveIcon from "../Icons/ExclusiveIcon";
import ExclusiveHoverIcon from "../Icons/ExclusiveHoverIcon";
import {createAnalyticsEvent, getAnalyticsV2Proxy} from "../../../analytics/analyticsUtils";

const Exclusive = ({domainCountry}) => {
  const [iconToShow, setIconToShow] = useState("exclusive")
  const showIcon = (iconName) => () => {
    setIconToShow(iconName)
  }

  const moveToHotWaterPage = () => () => {
    getAnalyticsV2Proxy().push(createAnalyticsEvent("clickPromoBadge", {
      promotion: "Exclusive Extras",
      origin: "PDP"
    }));
    let domain = "com.au";
    if (domainCountry === "NZ") {
      domain = "co.nz";
    }

    const url = `https://www.reece.${domain}/hot-water-season`;
    window.open(url, "_blank");
  }

  return (
      <>
        {iconToShow === "exclusive" ? <ExclusiveIcon onHoverStart={showIcon("exclusiveHover")} /> : null}
        {iconToShow === "exclusiveHover" ? (<ExclusiveHoverIcon onClick={moveToHotWaterPage()} onHoverEnd={showIcon("exclusive")} />) : null}
      </>
  );
}

export default Exclusive;